/* globals $ */
'use strict';

$(function () {
  $('html').css('background-color', $('body').css('background-color'));

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android|iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) {
    $('body').addClass('can-download-app');
  }

  $('#hand-with-phone')
    .on('load', function () {
      $('.feature-image').addClass('loaded');
    })
    .each(function () {
      if (this.complete) {
        $(this).trigger('load');
      }
    });
});
